"use client";

import React from "react";
import Script from "next/script";

const FaqSchemaContactPage = () => {
    const faqJsonLd = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
            {
                "@type": "Question",
                name: "What is the best age to start swimming lessons for kids?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "The best age to start swimming lessons with us is 4 years old. At this age, children are more receptive to taking in instruction, which helps enhance their physical, cognitive, and emotional development through swimming."
                }
            },
            {
                "@type": "Question",
                name: "How long does it usually take for a child to learn to swim a short distance?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "On average, it takes about 40 lessons to swim a short distance. Progress varies based on individual learning pace and lesson consistency."
                }
            },
            {
                "@type": "Question",
                name: "Do parents need to be in the water with their child during lessons?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "No, we recommend parents allow their child to spend sufficient time building a bond with their coach during trial sessions."
                }
            },
            {
                "@type": "Question",
                name: "What should I bring to my swimming lesson on the first day?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Bring swimwear, goggles, a swim cap, and a kickboard. For children under 8, a thermal swimsuit is recommended. You can purchase missing items from the admin."
                }
            },
            {
                "@type": "Question",
                name: "How do I enter the swimming complex?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Tickets can be purchased on the ActiveSG website. Scan the ticket barcode at the pool entrance to enter."
                }
            },
            {
                "@type": "Question",
                name: "Are there swimming lessons on the fifth week of every month?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Yes, lessons are conducted on the fifth week unless otherwise informed."
                }
            },
            {
                "@type": "Question",
                name: "Will swimming lessons be conducted on rainy days?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Yes, lessons proceed as usual. For thunderstorms, a land-based bad weather program will be done in sheltered areas."
                }
            },
            {
                "@type": "Question",
                name: "Are replacement classes available if students are unable to attend due to personal reasons or illness?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Replacement classes are only for Gold Package. Notify us 1 day in advance or present a medical certificate. Credits will be issued via the Parent Portal."
                }
            },
            {
                "@type": "Question",
                name: "Do I need to pay any registration fees or deposits?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "No registration fees or deposits. But students at ActiveSG pools must pay entrance fees."
                }
            },
            {
                "@type": "Question",
                name: "What should I do if my child is unable to follow through the trial?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Stay calm and positive. Understand your child’s discomfort and avoid leaving immediately so they don't associate crying with quitting."
                }
            },
            {
                "@type": "Question",
                name: "Can I have private swimming lessons at my condominium or apartment?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Yes, if your condo management approves instructor entry, we can conduct private lessons there."
                }
            },
            {
                "@type": "Question",
                name: "Who do I contact for swimming lesson enquiries or make-up/replacement lessons?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Please contact our Support Team via WhatsApp at 6582221357. Save the number for WhatsApp broadcast updates."
                }
            },
            {
                "@type": "Question",
                name: "When and how do I make payment for the monthly swim lessons?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Payment is due two weeks before the term starts. Pay via Stripe (no admin fee), or Bank Transfer/PayNow UEN (with $5 admin fee). Confirm details with the school."
                }
            },
            {
                "@type": "Question",
                name: "How do I register for a swimming class?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Start with a trial class to see if your child is comfortable. If yes, inform us and our team will help you with full registration."
                }
            },
            {
                "@type": "Question",
                name: "How many students are there in group swimming lessons?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Class sizes average 5 students, with a maximum of 10, following ActiveSG policies."
                }
            },
            {
                "@type": "Question",
                name: "What are the SwimSafer requirements?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "The SwimSafer program is recognized by MOE and has specific requirements for each stage to ensure safety and skill progress."
                }
            },
            {
                "@type": "Question",
                name: "Will my child’s progress be affected if they do not take the SwimSafer test?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "No. The test is optional. But taking it provides formal assessment and progression proof."
                }
            },
            {
                "@type": "Question",
                name: "What facilities are available at the swimming complex?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Facilities vary. Some pools have sheltered areas and other features. Check ActivesgCircle.gov.sg for specific pool facilities."
                }
            }
        ]
    };

    return (
        <Script
            id="faq-schema"
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
        />
    );
};

export default FaqSchemaContactPage;
